import React, { useState, useContext } from "react";
import Rating from "react-rating";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

// styles
import styles from "./styles.module.scss";

// assets
import starFilled from "src/assets/images/details/star_filled.svg";
import star from "src/assets/images/details/star.svg";

// context
import UserContext from "src/context/User";
import { postReview } from "../../api";

const ReviewModal = ({ data, toggle }) => {
  const { user } = useContext(UserContext);

  const [userText, setUserText] = useState("");
  const [rating, setRating] = useState(0);

  const getUsername = () => {
    if (user?.userName !== "") return user?.userName;

    return user?.emailId?.split("@")[0];
  };

  const handleClick = () => {
    let obj = {
      userId: user?.userId,
      eventID: +data.EventId,
      ratings: rating,
      reviewText: userText,
      userName: getUsername(),
      userImagePath: user?.userImagePath,
    };

    postReview(obj)
      .then((res) => {
        if (res.data.Status) {
          toast.success("review submitted!!");
          toggle(true);
        } else {
          toast.error(res.data.ErrorMessage);
        }
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className={styles.review__modal__wrapper}
      onClick={() => toggle()}
    >
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        className={styles.review__modal}
        onClick={(e) => e.stopPropagation()}
      >
        {user ? (
          <>
            <h3>
              Thanks for <br /> your feedback
            </h3>
            <p>Write review about the Event.</p>
            <div className={styles.rating}>
              <Rating
                initialRating={rating}
                emptySymbol={<img src={star} alt="..." />}
                fullSymbol={<img src={starFilled} alt="..." />}
                onChange={(value) => setRating(value)}
              />
            </div>
            <textarea
              placeholder="Write review here..."
              onChange={(e) => setUserText(e.target.value)}
            />
            <div className={styles.btn__wrapper}>
              <button onClick={handleClick}>Submit</button>
              <button onClick={() => toggle()}>Cancel</button>
            </div>
          </>
        ) : (
          <div className={styles.no__user}>
            <h2>Please Login to write a review</h2>
            <Link to="/login">
              <button>Login</button>
            </Link>
          </div>
        )}
      </motion.div>
    </motion.div>
  );
};

export default ReviewModal;
